import React from 'react';
import OpenQuestion from './QuestionsTypes/OpenQuestion';
import DateQuestion from './QuestionsTypes/DateQuestion';
import EmailQuestion from './QuestionsTypes/EmailQuestion';
import PhoneQuestion from './QuestionsTypes/PhoneQuestion';
import { GetQuestionsConfiguration } from './Configuration/QuestionConfiguration';
import TinyLoader from './../../Components/Loader/TinyLoader';
import Parse from 'parse';
import {Admin} from './../../../configurations/Admin';

class Generals extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      questions: GetQuestionsConfiguration(),
      loading:false,
      isError:false,
      name:"", birthday:"", email:"", phone:"",
      isErrorName: false, isErrorBirthday: false, isErrorEmail: false, isErrorPhone: false,
      errorsName: [], errorsBirthday: [], errorsEmail: [], errorsPhone: [],
    }
  }

  isEmailInUse = async (email) =>{
    const {patient} = this.state;
    let currentUser = Parse.User.current();
    const Patient = Parse.Object.extend('Patient');
    if(patient.id === 0){
      //paciente nuevo
      const query = new Parse.Query(Patient);
      query.equalTo("doctor", currentUser);
      query.equalTo("email", email);
      let patientFounded = await query.count();
      if(patientFounded > 0){
        return true;
      }
      return false;
    }else{
      const queryExisting = new Parse.Query(Patient);
      queryExisting.equalTo("doctor", currentUser);
      queryExisting.equalTo("email", email);
      queryExisting.notEqualTo("objectId", patient.id);

      let patientFoundedExisting = await queryExisting.find();
      if(patientFoundedExisting.length === 0){
        return false;
      }
      return true;
    }
  }

  isPhoneInUse = async (phone) =>{
    const {patient} = this.state;
    let currentUser = Parse.User.current();
    const Patient = Parse.Object.extend('Patient');
    if(patient.id === 0){
      //paciente nuevo
      const query = new Parse.Query(Patient);
      query.equalTo("doctor", currentUser);
      query.equalTo("phone", phone);
      let patientFounded = await query.count();
      if(patientFounded > 0){
        return true;
      }
      return false;
    }else{
      const queryExisting = new Parse.Query(Patient);
      queryExisting.equalTo("doctor", currentUser);
      queryExisting.equalTo("phone", phone);
      queryExisting.notEqualTo("objectId", patient.id);

      let patientFoundedExisting = await queryExisting.find();
      if(patientFoundedExisting.length === 0){
        return false;
      }
      return true;
    }
  }

  countErrorsAndValidateFields = async () => {
    let errorsCounter = 0;
    const { name , birthday, email, phone } = this.state;
    
    this.setState({
      isErrorName: false, isErrorBirthday: false, isErrorEmail: false, isErrorPhone: false,
      errorsName: [], errorsBirthday: [], errorsEmail: [], errorsPhone: [],
    });

    if(name === ""){
      this.setState({isErrorName: true, errorsName: ["El nombre es obligatorio"]})
      errorsCounter += 1;
    }

    if(birthday === ""){
      this.setState({isErrorBirthday: true, errorsBirthday: ["La fecha de nacimiento es obligatoria"]})
      errorsCounter += 1;
    }

    if(email === ""){
      this.setState({isErrorEmail: true, errorsEmail: ["El correo electrónico es obligatorio"]})
      errorsCounter += 1;
    }else{
      if(!this.validateEmail(email)){
        this.setState({isErrorEmail: true, errorsEmail: ["Correo electrónico inválido"]})
        errorsCounter += 1;
      }else{
        if(await this.isEmailInUse(email)){
          this.setState({isErrorEmail: true, errorsEmail: ["Correo electrónico previamente registrado"]})
          errorsCounter += 1;
        }
      }
    }

    if(phone === ""){
      this.setState({isErrorPhone: true, errorsPhone: ["El teléfono es obligatorio"]})
      errorsCounter += 1;
    }else{
      if(await this.isPhoneInUse(phone)){
        this.setState({isErrorPhone: true, errorsPhone: ["Teléfono previamente registrado"]})
        errorsCounter += 1;
      }
    }

    return errorsCounter;
  }

  validateEmail = (email) => {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  getTagsForPatient(email, name, phone){
    const tags = [];
    if(email){
        if(email !== null)
            tags.push(email.toLowerCase());
    }

    if(name){
        const nameComponents = name.split(' ');
        if(nameComponents){
            if(nameComponents.length > 0){
                for(let nameComponent in nameComponents){
                    tags.push(nameComponents[nameComponent].toLowerCase());
                }
            }
        }

        if(name !== null)
            tags.push(name.toLowerCase());
    }

    if(phone){
        if(phone !== null)
            tags.push(phone.toLowerCase());
    }
    return tags;
}
  
  onSave = async () => {
    const { name , birthday, email, phone } = this.state;
    let currentUser = Parse.User.current();
    if(currentUser.get("username") === Admin.user_admin){
      this.setState({isError:true});
      return;
    }


    let {patient} = this.state;
    let errorsCounter = await this.countErrorsAndValidateFields();
    
    if(errorsCounter > 0){
      this.setState({isError:true});
      return;
    }

    this.setState({isError:false});

    const Patient = Parse.Object.extend('Patient');
    
    const tags = this.getTagsForPatient(email, name, phone);
    //new patient
    if(patient.id === 0){
      const myNewObject = new Patient();
      myNewObject.set("doctor", currentUser);
      myNewObject.set("name", name);
      myNewObject.set("birthday", birthday);
      myNewObject.set("email", email);
      myNewObject.set("phone", phone);
      myNewObject.set("tags", tags);

      
      //TODO:Show loader
      this.setState({loading: true});

      patient = await myNewObject.save();

      this.setState({loading: false});

      this.props.patientAdded(true, patient);
      return;
    }

    //Update patient
    const query = new Parse.Query(Patient);
    let patientFounded = await query.get(patient.id);
    patientFounded.set("name", name);
    patientFounded.set("birthday", birthday);
    patientFounded.set("email", email);
    patientFounded.set("phone", phone);
    patientFounded.set("tags", tags);

    this.setState({loading: true});

    await patientFounded.save();
    
    this.setState({loading: false});
  }

  handleChangeListener = (field, value) => {
    if(field === "name"){
      this.setState({name: value});
    }
    if(field === "birthday"){
      this.setState({birthday: value});
    }
    if(field === "email"){
      this.setState({email: value});
    }
    if(field === "phone"){
      this.setState({phone: value});
    }
  }

  updateQuestionsWithPatientData = (patient) => {
    if(patient === null || patient.id === 0){
      return;
    }
    
    this.setState({
      name:patient.get("name"), 
      birthday:patient.get("birthday"), 
      email:patient.get("email"), 
      phone:patient.get("phone"),
    });
  }

  componentDidMount = () => {
    this.updateQuestionsWithPatientData(this.props.patient);
    this.setState({patient: this.props.patient});
  }
  
  render() {
    const { name , birthday, email, phone } = this.state;
    const { isErrorName, isErrorBirthday, isErrorEmail, isErrorPhone} = this.state;
    const { errorsName, errorsBirthday, errorsEmail, errorsPhone } = this.state;

    const loading = this.state.loading ? <TinyLoader/> : null;

    let errorOnForm = null;
    if(this.state.isError){
      errorOnForm = <p className="error text-center">Existen algunos errores en el formulario</p>
    }

    const {patient} = this.state;
    if(patient === null){
      return <p>Usuario inválido</p>
    }else{
      if(!patient){
        return <p>cargando...</p>
      }
    }

    return(
      <div>
        <div>
          <div className="vertical-separator-20px"></div> 

          <h3>INFORMACIÓN GENERAL </h3>

          <span className="error">*Todos los campos son obligatorios</span> 
          
          <div className="vertical-separator-10px"></div>

          <OpenQuestion
            field={this.state.questions["name"].field}
            text={this.state.questions["name"].text}
            note={this.state.questions["name"].note}
            options={this.state.questions["name"].options}
            predefinedValue={name}
            predefinedOtherValue={this.state.questions["name"].predefinedOtherValue}
            placeHolder={this.state.questions["name"].placeHolder}
            rules={this.state.questions["name"].rules}
            type={this.state.questions["name"].type}
            value={name}
            otherValue={this.state.questions["name"].otherValue}
            isError={isErrorName}
            errors={errorsName}
            handleChangeListener={this.handleChangeListener}
          />
          
          <div className="vertical-separator-10px d-lg-none"></div> 

          <DateQuestion
            field={this.state.questions["birthday"].field}
            text={this.state.questions["birthday"].text}
            note={this.state.questions["birthday"].note}
            options={this.state.questions["birthday"].options}
            predefinedValue={birthday}
            predefinedOtherValue={this.state.questions["birthday"].predefinedOtherValue}
            placeHolder={this.state.questions["birthday"].placeHolder}
            rules={this.state.questions["birthday"].rules}
            type={this.state.questions["birthday"].type}
            value={birthday}
            otherValue={this.state.questions["birthday"].otherValue}
            isError={isErrorBirthday}
            errors={errorsBirthday}
            handleChangeListener={this.handleChangeListener}
          />

          <div className="vertical-separator-10px d-lg-none"></div> 

          <EmailQuestion
            field={this.state.questions["email"].field}
            text={this.state.questions["email"].text}
            note={this.state.questions["email"].note}
            options={this.state.questions["email"].options}
            predefinedValue={email}
            predefinedOtherValue={this.state.questions["email"].predefinedOtherValue}
            placeHolder={this.state.questions["email"].placeHolder}
            rules={this.state.questions["email"].rules}
            type={this.state.questions["email"].type}
            value={email}
            otherValue={this.state.questions["email"].otherValue}
            isError={isErrorEmail}
            errors={errorsEmail}
            handleChangeListener={this.handleChangeListener}
          />

          <div className="vertical-separator-10px"></div> 

          <PhoneQuestion
            field={this.state.questions["phone"].field}
            text={this.state.questions["phone"].text}
            note={this.state.questions["phone"].note}
            options={this.state.questions["phone"].options}
            predefinedValue={phone}
            predefinedOtherValue={this.state.questions["phone"].predefinedOtherValue}
            placeHolder={this.state.questions["phone"].placeHolder}
            rules={this.state.questions["phone"].rules}
            type={this.state.questions["phone"].type}
            value={phone}
            otherValue={this.state.questions["phone"].otherValue}
            isError={isErrorPhone}
            errors={errorsPhone}
            handleChangeListener={this.handleChangeListener}
          />
        </div>

        <div className="vertical-separator-20px"></div> 

        <div className="row justify-content-center">
          <div className="col-md-4 col-md-offset-4">
            {errorOnForm}
            <button
              className="button-outlined"
              onClick={this.onSave}
              >
              Guardar
            </button>
          </div>
          <div className="col-md-1">
            <div className="vertical-separator-10px"></div> 
            {loading}
          </div> 
        </div>

        <div className="vertical-separator-10px"></div> 

      </div>
    );
  }
}

export default Generals;



// WEBPACK FOOTER //
// ./src/views/Forms/Patient/Generals.js